import React, { useState } from 'react';
import styled from 'styled-components';

import CanvasStars from './CanvasStars';
import BackgroundImage from './BackgroundImage';
import Routing from '../containers/Routing';
import { useResize } from '../utils/hooks/useResize';

const AppWrap = styled.div`
  margin: auto;
  overflow: hidden;
`;

const App = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useResize(
    () =>
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      }),
    500
  );

  return (
    <AppWrap>
      <Routing />

      <BackgroundImage windowHeight={windowSize.height} />
      <CanvasStars width={windowSize.width} height={windowSize.height} />
    </AppWrap>
  );
};

export default App;
